module.exports = __webpack_public_path__ + "img/fundo-criancas.0fc8aea1.png";